var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9998 43.2C34.6037 43.2 43.1998 34.6039 43.1998 24C43.1998 13.3961 34.6037 4.79999 23.9998 4.79999C13.3959 4.79999 4.7998 13.3961 4.7998 24C4.7998 34.6039 13.3959 43.2 23.9998 43.2ZM26.3998 14.4001C26.3998 13.0746 25.3253 12.0001 23.9998 12.0001C22.6743 12.0001 21.5998 13.0746 21.5998 14.4001V23.0059C21.5998 24.2789 22.1055 25.4998 23.0057 26.4L28.3029 31.6972C29.2401 32.6344 30.7597 32.6344 31.697 31.6972C32.6342 30.7599 32.6342 29.2403 31.697 28.3031L26.3998 23.0059V14.4001Z",
    fill: "#FF9558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.508371996941e9fad356dbc18d6185cd.svg";
export { ForwardRef as ReactComponent };